import { type GridSortModel } from '@mui/x-data-grid'

type BeSortPayload = Array<{ direction: 'asc' | 'desc', field: string }>

export const toBeSortPayload = (model: GridSortModel): string => {
  if (!model?.length) return '[]'

  const { field, sort } = model[0] // MUI uses sort: 'asc' | 'desc'
  return JSON.stringify([
    { field, direction: sort ?? 'asc' }
  ])
}

export const toBeSortPayloadUnparsed = (model: GridSortModel): BeSortPayload => {
  if (!model?.length) return []

  const { field, sort } = model[0]
  return [{ field, direction: (sort ?? 'asc') }]
}
